var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallationQueueSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8 6.60019V7.11342V16.6797C21.8 17.2985 21.1232 17.8001 20.2882 17.8001H4.91165C4.07679 17.8001 3.39999 17.2985 3.39999 16.6798V7.21553V6.6001",
    stroke: "#00ACC5",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79707 5.8H2.67499C1.7499 5.8 1 5.33463 1 4.76055L2.52778 2.0395C3.00982 1.21117 3.27768 1 4.20278 1H13L11.4722 4.76046C11.1459 5.43589 10.7222 5.8 9.79707 5.8Z",
    stroke: "#00ACC5",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3127 5.8H23.3459C24.2594 5.8 25 5.33463 25 4.7605L23.4913 2.0395C22.8777 1.07776 22.7507 1 21.8372 1H13L14.4543 4.7605C14.7689 5.45076 15.3991 5.8 16.3127 5.8Z",
    stroke: "#00ACC5",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1V18.6",
    stroke: "#00ACC5",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationQueueSearch);
export default __webpack_public_path__ + "static/media/installation_queue_search.2e0a13434673b5c7a533abf67f0fa49d.svg";
export { ForwardRef as ReactComponent };